import CrispManager from './crisp-manager/crisp-manager';
import LoggerManager from './logger-manager/logger-manager';
import LogoutManager from './logout-manager/logout-manager';
import MainMenuManager from './main-menu-manager/main-menu-manager';
import ModalManager from './modal-manager/modal-manager';
import ScrollManager from './scroll-manager/scroll-manager';

export default [
  CrispManager,
  LoggerManager,
  LogoutManager,
  MainMenuManager,
  ModalManager,
  ScrollManager,
];
